// src/pages/Watchlist/WatchlistItem.jsx
import React from 'react'
import Image from 'next/image'
import styles from './styles.module.scss'

const WatchlistItem = ({ src, alt, text, onClick }) => (
  <div className={styles.item} onClick={onClick}>
    <div className={styles.itemImage}>
      <Image src={src} width={80} height={80} alt={alt} />
    </div>
    <div className={styles.itemText}>{text}</div>
  </div>
)

export default WatchlistItem
